import React, {useState} from "react";
import {Typography} from "@mui/material";
import enterpriseObjectClassFactory from "../eoec/EnterpriseObjectClassFactory";
import EnterpriseObject from "../eoec/eo/EnterpriseObject";
import ETLS3ConfigurationTableApplet from "../eoec/applet/impl/ETLS3Configuration/ETLS3ConfigurationTableApplet";


export default function S3() {
    const [etlS3ConfigurationEnterpriseObject] = useState(enterpriseObjectClassFactory("ETLS3Configuration") as EnterpriseObject);

    function renderS3Configurations() {

        return (
            <>
                <div style={{display: "flex", flexDirection: "column", margin: "20px 20px 20px 20px"}}>
                   <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", margin: "30px 0 0 0"}}>
                        <ETLS3ConfigurationTableApplet enterpriseComponent={etlS3ConfigurationEnterpriseObject?.getEnterpriseComponent("ETLS3Configuration")}/>
                    </div>
                </div>
            </>
        )
    }

    return (
        <div style={{display: "flex", flexDirection: "column", flexGrow: 1}}>
            <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", height: 52, backgroundColor: "#1498D8"}}>
                <div style={{paddingTop: "9px", paddingLeft: "20px"}}>
                    <Typography style={{fontSize: 24, fontWeight: 400, color: "#FFFFFF"}}>S3 Configurations</Typography>
                </div>
            </div>
            {renderS3Configurations()}
        </div>
    );
}